module.exports = __webpack_public_path__ + "img/spartan-build-design-01-large.546eed03.jpg";